import { useSearchParams } from 'react-router-dom';

import { getValidSsoProviderId } from '@neo.tax/shared';

// URL values anyone can set: they pick which sign-in to offer and never grant access.
export const useSsoInvitation = (): { inviteToken: string; ssoProviderId: string } | null => {
  const [searchParams] = useSearchParams();
  const inviteToken = searchParams.get('inviteToken');
  const ssoProviderId = getValidSsoProviderId(searchParams.get('ssoProviderId'));
  return inviteToken && ssoProviderId ? { inviteToken, ssoProviderId } : null;
};
